import React, { useState, useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import axios from 'axios';
import envConfig from '../../../bin/env.config';
import { useSelector } from 'react-redux';
import DialogCheckAndUpdateStoreStatus from './DialogCheckAndUpdateStoreStatus';
import { STATUS_ICONS, STATUS_COLORS, BACKGROUND_STATUS_COLORS } from '../../../utility/statusConfig';

const StoreStatusIcon = ({ cellData, setCellColor, onStatusSaved, reportContext }) => {
  const [statusData, setStatusData] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const token = useSelector((state) => state.session.token);
  const changeCellStatus = (status) => {
    setStatusData(status);
    setCellColor(BACKGROUND_STATUS_COLORS[status.status_id]);
    if (onStatusSaved) {
      onStatusSaved(status, reportContext);
    }
  };

  useEffect(() => {
    const loadStatusData = async () => {
      try {
        const response = await axios.post(
          `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/out-of-date-store-check-info`,
          {
            company_product_id: cellData.company_product_id,
            store_id: cellData.store_id,
          },
          {
            headers: {
              Authorization: token,
            },
          }
        );
        setStatusData(response.data.data);
        setCellColor(BACKGROUND_STATUS_COLORS[response.data.data.status_id]);
      } catch (error) {
        console.error('Error loading store status data:', error);
      }
    };

    if (cellData.company_product_id && cellData.store_id) {
      loadStatusData();
    }
  }, [cellData.company_product_id, cellData.store_id, token]);

  if (!statusData) return null;

  return (
    <>
      <IconButton
        size="small"
        onClick={() => setOpenDialog(true)}
        style={{
          color: STATUS_COLORS[statusData.status_id],
          padding: 0,
        }}
      >
        {STATUS_ICONS[statusData.status_id]}
      </IconButton>

      <DialogCheckAndUpdateStoreStatus
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        statusData={statusData}
        setStatusData={changeCellStatus}
      />
    </>
  );
};

const StoreDateStatusCell = ({ cellData, setCellColor, onStatusSaved, reportContext }) => {
  const [isBold, setIsBold] = useState(false);
  const [isBlue, setIsBlue] = useState(false);

  const handleDateClick = () => {
    if (cellData.external_link) {
      let urlToOpen = cellData.external_link;
      try {
        const url = new URL(cellData.external_link);
        if (cellData.store_id) {
          url.searchParams.set('bcpc_store_id', cellData.store_id);
        }
        if (cellData.company_product_id) {
          url.searchParams.set('bcpc_company_product_id', cellData.company_product_id);
        }
        urlToOpen = url.toString();
      } catch (error) {
        // Fall back to the original link.
      }
      window.open(urlToOpen, '_blank');
      if (cellData.store_postal) {
        navigator.clipboard.writeText(String(cellData.store_postal));
      }
      setIsBold(true);
      setIsBlue(true);

      setTimeout(() => {
        setIsBlue(false);
      }, 10000);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span
        onClick={handleDateClick}
        style={{
          cursor: cellData?.external_link ? 'pointer' : 'default',
          color: isBlue ? '#0066cc' : isBold ? '#f9ff0d' : 'inherit',
          fontWeight: isBold ? 'bold' : 'normal',
        }}
      >
        {cellData?.date ? new Date(cellData.date).toLocaleDateString() : ''}
      </span>

      {cellData?.not_updated === 1 && (
        <StoreStatusIcon
          cellData={cellData}
          setCellColor={setCellColor}
          onStatusSaved={onStatusSaved}
          reportContext={reportContext}
        />
      )}
    </div>
  );
};

export default StoreDateStatusCell;
